<div *ngIf="projetInspectionListLoading$ | async" class="spinner-placeholder">
    <app-loading-spinner></app-loading-spinner>
</div>

<ng-container *ngIf="projetInspectionList$ | async as projetInspectionList">
    <app-projet-inspection-list [projetInspection]="projetInspectionList"></app-projet-inspection-list>
</ng-container>